import { render, staticRenderFns } from "./TreeChartLoader.vue?vue&type=template&id=32013c94&"
import script from "./TreeChartLoader.vue?vue&type=script&lang=js&"
export * from "./TreeChartLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports